export default __webpack_public_path__ + "static/media/key.29f7fad9.svg";